import { Box, CircularProgress } from '@material-ui/core'
import React from 'react'
import { useWatch } from 'react-hook-form'
import styled from 'styled-components'

const CircularProgressLabel = styled.span`
  font-weight: 500;
  line-height: 1;
`

const MaxLengthContainer = styled.div<{ $isOverflow: boolean }>`
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  color: ${({ $isOverflow, theme }) =>
    $isOverflow ? theme.colors.semantic.error : theme.colors.coolGray.cool600};
`

const CircularProgressWithLabel: React.VFC<{ label: string; value: number }> = ({
  label,
  value,
}) => (
  <Box position="relative" display="inline-flex" ml={3}>
    <CircularProgress variant="determinate" value={value} color="inherit" />
    <Box
      top={0}
      left={0}
      bottom={0}
      right={0}
      position="absolute"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgressLabel>{label}</CircularProgressLabel>
    </Box>
  </Box>
)

export const MaxLengthProgress: React.VFC<{
  className?: string
  name: string
  maxLength: number
}> = ({ className, name, maxLength }) => {
  const fieldValue = useWatch({ name })
  const charCount = `${fieldValue}`.length
  const remainingChars = maxLength - charCount
  return (
    <MaxLengthContainer className={className} $isOverflow={remainingChars < 0}>
      <span>Remaining characters:</span>
      <CircularProgressWithLabel
        label={`${remainingChars}`}
        value={Math.min(100, (charCount * 100) / maxLength)}
      />
    </MaxLengthContainer>
  )
}

export const MaxLengthProgressAdornment = styled(MaxLengthProgress)`
  // force adornment to wrap
  width: 100%;
  margin-top: 15px;
`
